import { Protocol } from '../Protocol';

export class TypeProtocol {
  public static readonly ALL_TYPES: string = `${Protocol.YATUNG_API_ROOT}/type/all`; // 取得所有類別
}
